import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '@services/modal/modal.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor(
    private translate: TranslateService,
    private modalService: ModalService,
  ) {}

  public showError(error: HttpErrorResponse, closePreviousModal = true): void {
    if (error?.error?.status === 'expired') {
      this.translate.get('errors.expired')
        .subscribe(data => this.modalService.showMsg(data, null, {closePreviousModal}));
    }

    // @ts-ignore
    else if (error?.type === 'validation_error') this.modalService.showMsg(error.message, null, {closePreviousModal});
    // @ts-ignore
    else if (error?.type === 'invalid_request_error') this.modalService.showMsg(error.message, null, {closePreviousModal});
    else if (error?.error?.error) {
      const msg = error.error.error;
      this.modalService.showMsg(msg, null, {closePreviousModal});
      return;
    }
    else if (error?.error?.errors) {
      let msg = error.error.message;
      for (const [key, value] of Object.entries(error.error.errors)) {
        for (const additionalMsg of value as Array<string>) {
          msg += ` ${additionalMsg}`;
        }
      }
      this.modalService.showMsg(msg, null, {closePreviousModal});

    } else {

      if (typeof error?.error === 'string') {
        this.modalService.showMsg(error.error, null, {closePreviousModal});
        return;
      }

      if (typeof error === 'string') {
        this.modalService.showMsg(error, 600, {closePreviousModal});
        return;
      }

      if (error?.error?.message) {
        const msg = error?.error?.message as string;
        console.log(msg);

        if (msg === 'This period is already booked!')  {
          this.translate.get('errors.booked')
              .subscribe(data => {
                this.modalService.showMsg(data, null, {closePreviousModal});
              });
          return;
        }

        else if (msg === 'Device in group with active playlist')  {
          this.translate.get('errors.canNotDeleteDevice')
              .subscribe(data => {
                this.modalService.showMsg(data, null, {closePreviousModal});
              });
          return;
        }

        const mediaUsedPrefix = 'Selected media is used in following playlists:';

        if (msg.startsWith(mediaUsedPrefix)) {
          const playlists = msg
              .slice(mediaUsedPrefix.length);
          this.translate.get('errors.mediaIsUsed')
              .subscribe(data => {
                this.modalService.showMsg(data + playlists, null, { closePreviousModal });
              });
          return;
        }

        this.modalService.showMsg(msg, 600, {closePreviousModal});
        return;
      }

      if (error?.message) {
        this.modalService.showMsg(error?.message, 600, {closePreviousModal});
        return;
      }
      const errorText = error?.error?.message || 'Unexpected error on server';
      this.modalService.showMsg(errorText, null, {closePreviousModal});
    }
  }
}
